module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-02.8c24a1f8.jpg";